import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface GradingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Grading: React.FC<GradingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [grading, set_grading] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Grading'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Grading': v } } })
    );
    const label = 'Grading';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(grading)}
                />
            ) : (
                <MoneyBox
                    id={'grading'}
                    allowNegative={false}
                    value={grading}
                    onChange={(value) => set_grading(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
